<script setup lang="ts">
    import type { Component } from 'vue';
    import { Dialog, DialogContent } from '@/shared/ui/Dialog';
    import { useAuthDialogStore, type ModalState } from './auth-dialog-store';
    import LoginView from './Views/LoginView.vue';
    import ResetPasswordView from './Views/ResetPasswordView.vue';
    import LinkSentView from './Views/LinkSentView.vue';

    const store = useAuthDialogStore();

    const views: Record<ModalState, Component> = {
        login: LoginView,
        'reset-password': ResetPasswordView,
        'password-reset-sent': LinkSentView,
    };

    const currentViewComponent = computed(() => views[store.modalState]);

    onBeforeMount(() => store.resetModalState());
    onUnmounted(() => store.$dispose());
</script>

<template>
    <Dialog default-open>
        <DialogContent>
            <component :is="currentViewComponent" />
        </DialogContent>
    </Dialog>
</template>
